import React, { createContext, useContext, useState, useMemo } from 'react';

const LanguageContext = createContext();

export const translations = {
  tr: {
    nav: {
      home: 'Anasayfa',
      about: 'Hakkımızda',
      services: 'Hizmetlerimiz',
      blog: 'Blog',
      contact: 'İletişim',
      getAppointment: 'Randevu Al'
    },
    hero: {
      title: 'E-Ticaret & Dijital Danışmanlık',
      subtitle: 'Başarının iki ayağı vardır; biri siz, diğeri danışmanınız.',
      description: 'Bu yüzden başarı için doğru danışmanı seçmelisiniz.',
      cta: 'Hemen Başlayın',
      contact: 'İletişime Geçin'
    },
    about: {
      title: 'Biz Kimiz?',
      description: 'MRK Digital olarak, işletmelerin çevrimiçi hedeflerine ulaşmasına ve müşteri tabanlarını büyütmelerine ilham veren, yenilikçi çözümler sunan alanında uzman bir E-Ticaret ve Dijital Pazarlama ajansıyız.'
    },
    approach: {
      title: 'Neler Yaparız?',
      description: 'Kapsamlı uzmanlığımızla, her işletmeye özel büyüme stratejileri geliştiriyoruz. Veri odaklı çalışarak, ölçülebilir sonuçlar elde ediyoruz.'
    },
    stats: {
      clients: 'Aktif Müşteri',
      adsManaged: 'Yönetilen Reklam',
      projects: 'Tamamlanan Proje',
      experience: 'Yıllık Tecrübe'
    },
    brands: {
      badge: 'Güvenilir Partnerlerimiz',
      title: 'Birlikte Büyüdüğümüz Markalar',
      subtitle: 'Türkiye\'nin önde gelen markalarının dijital dönüşüm yolculuğunda yanlarındayız.',
      moreStories: 'Ve daha birçok başarı hikayesi...'
    },
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'Geniş Kapsamlı Hizmetler',
      ecommerce: {
        title: 'E-Ticaret',
        description: 'Satışlarınızı artıran e-ticaret stratejileri ve platform yönetimi'
      },
      performance: {
        title: 'Performans Pazarlama',
        description: 'ROI odaklı dijital pazarlama kampanyaları ve optimizasyon'
      },
      analysis: {
        title: 'Rekabet Analizi',
        description: 'Pazardaki konumunuzu güçlendiren detaylı analiz ve raporlama'
      },
      branding: {
        title: 'Marka Yönetimi',
        description: 'Markanızı öne çıkaran stratejik marka geliştirme ve yönetim'
      },
      design: {
        title: 'Tasarım',
        description: 'Kullanıcı deneyimini mükemmelleştiren modern tasarım çözümleri'
      },
      business: {
        title: 'İş Geliştirme',
        description: 'Büyümenizi hızlandıran stratejik iş geliştirme danışmanlığı'
      }
    },
    testimonials: {
      title: 'Müşterilerimiz Ne Diyor?',
      reviews: [
        {
          name: 'Tolga Tunçsav',
          company: 'Founder',
          companyLogo: '/brands/saf.avif',
          rating: 5,
          text: 'MRK Digital\'ı öne çıkaran, markamıza kendi markalarına gösterdikleri sahiplenme ve özenle yaklaşmalarıdır. En başından itibaren, e-ticaret ve pazar yeri danışmanlığı, performans pazarlama ve web geliştirme konularında hedeflerimizle tam uyumlu bir ekiple iş birliği yaptık. Bu düzeyde bir bağlılık ve stratejik ortaklık bizim için son derece değerli oldu.'
        },
        {
          name: 'Gizem Vitoşa',
          company: 'Marketing Director',
          companyLogo: '/brands/imuneks-transparent.png',
          rating: 5,
          text: 'MRK Digital ekibiyle çalışmaya başladığımızdan beri, hem web sitemiz hem de dijital pazarlama operasyonlarımız çok daha entegre ve verimli hale geldi. SEO\'dan performans reklamcılığına kadar, markamızı gerçekten anlayan ve sürecin her adımında bizimle aynı hedefleri paylaşan bir ekiple çalıştık.'
        }
      ]
    },
    blog: {
      title: 'Blog',
      readMore: 'Devamını Oku'
    },
    blogPost: {
      backToHome: 'Ana Sayfaya Dön',
      backToBlog: 'Bloga Dön'
    },
    cookies: {
      title: 'Çerez Tercihlerini Özelleştir',
      subtitle: 'Gezinmenize yardımcı olmak ve belirli işlevleri gerçekleştirmek için çerezler kullanıyoruz.',
      description: 'Her rıza kategorisi altında tüm çerezler hakkında detaylı bilgi bulacaksınız.',
      necessaryInfo: '"Gerekli" olarak kategorize edilen çerezler, sitenin temel işlevlerini etkinleştirmek için gerekli olduklarından tarayıcınızda saklanır.',
      bannerTitle: 'Gizliliğinize değer veriyoruz',
      bannerDescription: 'Gezinme deneyiminizi geliştirmek, kişiselleştirilmiş reklamlar veya içerik sunmak ve trafiğimizi analiz etmek için çerezler kullanıyoruz. "Tümünü Kabul Et" butonuna tıklayarak çerez kullanımımızı kabul etmiş olursunuz.',
      customise: 'Özelleştir',
      showMore: 'Daha fazla göster',
      showLess: 'Daha az göster',
      necessary: 'Gerekli',
      necessaryDesc: 'Gerekli çerezler, güvenli giriş sağlama veya rıza tercihlerinizi ayarlama gibi bu sitenin temel özelliklerini etkinleştirmek için gereklidir.',
      functional: 'İşlevsel',
      functionalDesc: 'İşlevsel çerezler, web sitesinin içeriğini sosyal medya platformlarında paylaşma gibi belirli işlevleri gerçekleştirmeye yardımcı olur.',
      analytics: 'Analitik',
      analyticsDesc: 'Analitik çerezler, ziyaretçilerin web sitesiyle nasıl etkileşimde bulunduğunu anlamak için kullanılır.',
      performance: 'Performans',
      performanceDesc: 'Performans çerezleri, web sitesinin temel performans indekslerini anlamak ve analiz etmek için kullanılır.',
      advertisement: 'Reklam',
      advertisementDesc: 'Reklam çerezleri, daha önce ziyaret ettiğiniz sayfalara göre özelleştirilmiş reklamlar sunmak için kullanılır.',
      alwaysActive: 'Her Zaman Aktif',
      rejectAll: 'Tümünü Reddet',
      savePreferences: 'Tercihlerimi Kaydet',
      acceptAll: 'Tümünü Kabul Et'
    },
    contact: {
      title: 'Bizimle İletişime Geçin',
      subtitle: 'Başarıyı Birlikte Üstlenelim!',
      tagline: 'Başarınız önceliğimizdir.',
      letsChat: 'Haydi',
      chat: 'Konuşalım',
      bookCall: 'Görüşme Ayarla',
      alternative: 'Veya direkt email gönderin:',
      steps: {
        chat: {
          title: 'Sohbet Edelim',
          desc: 'Bize projenizden ve hedeflerinizden bahsedin.'
        },
        book: {
          title: 'Görüşme Planla',
          desc: 'Uygun bir saat seçin, konuşalım.'
        },
        email: {
          title: 'E-posta Gönderin',
          desc: 'En kısa sürede size geri döneceğiz.'
        }
      },
      name: 'Adınız',
      email: 'E-posta',
      phone: 'Telefon',
      company: 'Şirket',
      message: 'Mesajınız',
      submit: 'Gönder',
      success: 'Mesajınız başarıyla gönderildi!',
      error: 'Bir hata oluştu. Lütfen tekrar deneyin.'
    },
    footer: {
      about: 'Hakkımızda',
      services: 'Hizmetlerimiz',
      subscribe: 'Abone Ol',
      rights: 'Tüm hakları saklıdır.',
      description: 'Dijital dünyada işinizi büyütmek için stratejik çözümler sunuyoruz.',
      privacy: 'Gizlilik Politikası',
      terms: 'Kullanım Koşulları'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      blog: 'Blog',
      contact: 'Contact',
      getAppointment: 'Get Appointment'
    },
    hero: {
      title: 'E-Commerce & Digital Consultancy',
      subtitle: 'Success has two pillars; one is you, the other is your consultant.',
      description: 'That\'s why you must choose the right consultant for success.',
      cta: 'Get Started',
      contact: 'Contact Us'
    },
    about: {
      title: 'Who We Are?',
      description: 'As MRK Digital, we are an expert E-Commerce and Digital Marketing agency that offers innovative solutions, inspiring businesses to reach their online goals and grow their customer base.'
    },
    approach: {
      title: 'What We Do?',
      description: 'With our comprehensive expertise, we develop customized growth strategies for each business. Working data-driven, we achieve measurable results.'
    },
    stats: {
      clients: 'Active Clients',
      adsManaged: 'Ads Managed',
      projects: 'Completed Projects',
      experience: 'Years of Experience'
    },
    brands: {
      badge: 'Trusted Partners',
      title: 'Brands We\'ve Helped Grow',
      subtitle: 'Partnering with Turkey\'s leading brands on their digital transformation journey.',
      moreStories: 'And many more success stories...'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive Services',
      ecommerce: {
        title: 'E-Commerce',
        description: 'E-commerce strategies and platform management that increase your sales'
      },
      performance: {
        title: 'Performance Marketing',
        description: 'ROI-focused digital marketing campaigns and optimization'
      },
      analysis: {
        title: 'Competitive Analysis',
        description: 'Detailed analysis and reporting that strengthens your market position'
      },
      branding: {
        title: 'Brand Management',
        description: 'Strategic brand development and management that highlights your brand'
      },
      design: {
        title: 'Design',
        description: 'Modern design solutions that perfect the user experience'
      },
      business: {
        title: 'Business Development',
        description: 'Strategic business development consultancy that accelerates your growth'
      }
    },
    testimonials: {
      title: 'What Our Clients Say?',
      reviews: [
        {
          name: 'Tolga Tunçsav',
          company: 'Founder',
          companyLogo: '/brands/saf.avif',
          rating: 5,
          text: 'What distinguishes MRK Digital is their approach of treating our brand with the same ownership and care as their own. From the very beginning, we have collaborated with a team that is fully aligned with our objectives across e-commerce and marketplace consulting, performance marketing, and web development. This level of commitment and strategic partnership has been highly valuable for us.'
        },
        {
          name: 'Gizem Vitoşa',
          company: 'Marketing Director',
          companyLogo: '/brands/imuneks-transparent.png',
          rating: 5,
          text: 'Since we started working with the MRK Digital team, both our website and digital marketing operations have become much more integrated and efficient. From SEO to performance advertising, they\'ve been a team that truly understands our brand and shares the same goals with us throughout every step of the process.'
        }
      ]
    },
    cookies: {
      title: 'Customise Consent Preferences',
      subtitle: 'We use cookies to help you navigate efficiently and perform certain functions.',
      description: 'You will find detailed information about all cookies under each consent category below.',
      necessaryInfo: 'The cookies that are categorised as "Necessary" are stored on your browser as they are essential for enabling the basic functionalities of the site.',
      bannerTitle: 'We value your privacy',
      bannerDescription: 'We use cookies to enhance your browsing experience, serve personalised ads or content, and analyse our traffic. By clicking "Accept All", you consent to our use of cookies.',
      customise: 'Customise',
      showMore: 'Show more',
      showLess: 'Show less',
      necessary: 'Necessary',
      necessaryDesc: 'Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences.',
      functional: 'Functional',
      functionalDesc: 'Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms.',
      analytics: 'Analytics',
      analyticsDesc: 'Analytical cookies are used to understand how visitors interact with the website.',
      performance: 'Performance',
      performanceDesc: 'Performance cookies are used to understand and analyse the key performance indexes of the website.',
      advertisement: 'Advertisement',
      advertisementDesc: 'Advertisement cookies are used to provide visitors with customised advertisements based on the pages you visited previously.',
      alwaysActive: 'Always Active',
      rejectAll: 'Reject All',
      savePreferences: 'Save My Preferences',
      acceptAll: 'Accept All'
    },
    blog: {
      title: 'Blog',
      readMore: 'Read More'
    },
    blogPost: {
      backToHome: 'Back to Home',
      backToBlog: 'Back to Blog'
    },
    contact: {
      title: 'Get In Touch',
      subtitle: 'Let\'s Achieve Success Together!',
      tagline: 'Your success is our priority.',
      letsChat: 'Let\'s',
      chat: 'CHat',
      bookCall: 'Book a call',
      alternative: 'Or email us directly:',
      steps: {
        chat: {
          title: 'Let\'s Chat',
          desc: 'Tell us about your project and your goals.'
        },
        book: {
          title: 'Book a Call',
          desc: 'Choose a time and let\'s talk.'
        },
        email: {
          title: 'Email Us',
          desc: 'We\'ll get back to you as soon as possible.'
        }
      },
      name: 'Your Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      message: 'Your Message',
      submit: 'Submit',
      success: 'Your message has been sent successfully!',
      error: 'An error occurred. Please try again.'
    },
    footer: {
      about: 'About',
      services: 'Services',
      subscribe: 'Subscribe',
      rights: 'All rights reserved.',
      description: 'We provide strategic solutions to grow your business in the digital world.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = translations[language];

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(() => ({
    language,
    setLanguage,
    toggleLanguage,
    t
  }), [language, t]);

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
